window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderAutoplay = e.dataset.autoplay,
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);

    if (sliderAutoplay == "true") {
      autoPlayValue = {
        delay: autoPlayTime,
      };
    }

    if (loopSelector == "true") {
      loopInit = true;
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      mobileShow = parseInt(e.dataset.showMobile);
      if (typeof e.dataset.showTablet !== "undefined") {
        tabletShow = e.dataset.showTablet;
      } else {
        tabletShow = extraLargeDesktopShow;
      }
    } else {
      sliderContainer = false;
    }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      autoplay: autoPlayValue,
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
        type: "fraction",
      },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });

    if (!sliderContainer == false && sliderAutoplay == "true") {
      sliderContainer.addEventListener("mouseenter", (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener("mouseleave", (e) => {
        featuredCollection.autoplay.start();
      });
    }
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("accordion", theme.accordion);
  sections.register("blog", theme.blog);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});

/* === PP v7 (Oct 18): Bold Product Options emergency fixes ===
   1) Required single-choice swatch: clicking the already-selected swatch no longer
      un-selects it (Bold toggles checkbox swatches off, so a Bold default such as
      "24K Gold" was cleared by the shopper's first click -> "This option is required").
   2) Required-option guard on product form submit: visible required Bold swatch/radio/
      dropdown options must have a value (covers apps like Customily that bypass Bold's
      own validation, e.g. Pillow "Choose Sides*").
   3) Header cart count re-syncs from /cart.js after any cart add/change (Bold adds
      linked add-on products after the theme renders the count).
   4) Parvez-approved load defaults (Oct 18): Potato Parcel/Pal start with no Surprise Box
      selected (Total Extras $0); Classy products preset "Classy Gift Wrap?" to No.
   Remove this block to roll back. */
(function () {
  if (window.__ppOptionFixes) return; window.__ppOptionFixes = true;
  function isRequired(opt) {
    var t = opt && opt.querySelector('.bold_option_title');
    return !!t && /\*\s*$/.test(t.textContent.trim());
  }
  function isVisible(el) { return !!(el.offsetParent || el.getClientRects().length); }

  /* 1) keep a selected required swatch selected */
  document.addEventListener('click', function (e) {
    /* ignore the label's synthetic click on the input itself: by then the browser has already
       flipped .checked, so testing it there would cancel a genuine new selection */
    if (e.target.tagName === 'INPUT') return;
    var val = e.target.closest && e.target.closest('.bold_option_swatch .bold_option_value');
    if (!val) return;
    var opt = val.closest('.bold_option');
    if (!opt || opt.classList.contains('bold_option_swatch_multi') || !isRequired(opt)) return;
    var input = val.querySelector('input[type=checkbox]');
    if (input && input.checked) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* 2) required-option guard */
  function missingRequired(form) {
    var missing = [];
    form.querySelectorAll('.bold_options_loaded .bold_option').forEach(function (opt) {
      if (opt.classList.contains('bold_option_hidden') || !isVisible(opt) || !isRequired(opt)) return;
      if (!/bold_option_(swatch|radio|dropdown)\b/.test(opt.className)) return;
      var ok = false;
      opt.querySelectorAll('input[type=checkbox],input[type=radio]').forEach(function (i) { if (i.checked) ok = true; });
      opt.querySelectorAll('select').forEach(function (s) { if (s.value) ok = true; });
      if (!ok) missing.push(opt);
    });
    return missing;
  }
  function showError(opt) {
    if (opt.querySelector('.pp-required-error')) return;
    var m = document.createElement('div');
    m.className = 'pp-required-error';
    m.setAttribute('role', 'alert');
    m.style.cssText = 'color:#d9001b;font-size:14px;margin-top:6px;';
    m.textContent = 'This option is required.';
    opt.appendChild(m);
    opt.addEventListener('change', function () { m.remove(); }, { once: true });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector || !form.querySelector('.bold_options_loaded')) return;
    var miss = missingRequired(form);
    if (!miss.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    miss.forEach(showError);
    miss[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    form.querySelectorAll('[type=submit]').forEach(function (b) { b.classList.remove('loading'); b.removeAttribute('disabled'); });
  }, true);

  /* 3) header cart count sync */
  var timer;
  function syncCount() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (b) {
          var n = b.querySelector('#cart-notification-count, [aria-hidden="true"]');
          if (n) n.textContent = c.item_count;
          var v = b.querySelector('.visually-hidden');
          if (v) v.textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items');
        });
      }).catch(function () {});
    }, 400);
  }
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(en.name)) syncCount();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (err) {}
  }

  /* 4) Parvez-approved load defaults (Oct 18). Set the app's real state by changing the
        input and firing the 'change' event its handlers listen to (price/required/cart stay in sync).
        a) Potato Parcel / Potato Pal: un-select the pre-selected "24K Gold" in "Surprise Box Types".
        b) Classy products: preset "Classy Gift Wrap?" to No. */
  var path = location.pathname.replace(/^\/collections\/[^/]+/, '');
  var doBox = false; /* v9: no box untick */
  var doWrap = /^\/products\//.test(path); /* v9: wrap 'No' preset on every product page */
  function findOpt(re) {
    var opts = document.querySelectorAll('.bold_options_loaded .bold_option');
    for (var i = 0; i < opts.length; i++) {
      var t = opts[i].querySelector('.bold_option_title');
      if (t && re.test(t.textContent)) return opts[i];
    }
    return null;
  }
  function fire(input) { input.dispatchEvent(new Event('change', { bubbles: true })); }
  if (doBox || doWrap) {
    var touched = { box: false, wrap: false }, tries = 0, boxDone = false, wrapDone = false;
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('.bold_option');
      if (!o) return;
      var t = (o.querySelector('.bold_option_title') || {}).textContent || '';
      if (/Surprise Box Types/i.test(t)) touched.box = true;
      if (/Classy Gift Wrap/i.test(t)) touched.wrap = true;
    }, true);
    var iv = setInterval(function () {
      tries++;
      /* v9 (Oct 18): 24K Gold load-time untick REMOVED - Zepto's 24K Gold default stays selected. */
      if (doWrap && !touched.wrap && !wrapDone) {
        var wo = findOpt(/Classy Gift Wrap/i);
        if (wo) {
          var radios = wo.querySelectorAll('input[type=radio]'), any = false, no = null;
          radios.forEach(function (r) { if (r.checked) any = true; if (/^\s*No\s*$/i.test(r.value)) no = r; });
          if (!any && no) { no.checked = true; fire(no); }
          if (no && no.checked) wrapDone = true;
        }
      }
      /* keep watching ~12s (app may re-apply its default during init), stop early once settled */
      if (tries > 48 || ((!doBox || (boxDone && tries > 20)) && (!doWrap || wrapDone))) clearInterval(iv);
    }, 250);
  }

  /* 4c) The app removes its "Total Extras" line when extras are $0. On these pages show a
         display-only "$0" line instead (no inputs, so it never affects price or cart). */
  if (/^\/products\/(potato-parcel|potato-pal|classy-[^/]*)\/?$/.test(path)) {
    var syncZero = function (c) {
      var real = c.querySelector('.bold_option_total'), z = c.querySelector('.pp-extras-zero');
      if (real && z) z.remove();
      if (!real && !z) {
        z = document.createElement('div'); z.className = 'pp-extras-zero';
        z.innerHTML = '<div>Total Extras:  <span><span class="money">$ 0.00 USD</span></span></div>';
        c.appendChild(z);
      }
    };
    var w = setInterval(function () {
      var c = document.querySelector('.bold_options_loaded');
      if (!c) return;
      clearInterval(w); syncZero(c);
      new MutationObserver(function () { syncZero(c); }).observe(c, { childList: true });
    }, 250);
  }
})();

/* === PP v9 (Oct 18): mobile conversion fixes ===
   A) Add to Cart / sticky "Personalize & add to cart" blocked by a missing required option:
      scroll smoothly to the first missing option, highlight it, show the required message.
      Sticky button: one tap = real Add to Cart (or scroll to the missing option).
   B) "Classy Gift Wrap?" preset to No on every product page where it appears (until the shopper touches it).
   C) Image-swatch add-ons: obvious selected state (thick border, check badge, "Added +$X").
   D) Sticky bar price = product price + selected extras.
   E) Bold Upsell "Before you go..." pop-up: fits the viewport (max 90dvh, inner scroll),
      sticky footer "No thanks, continue" always visible, 44px close X.
   Remove this block to roll back (CSS is injected here too). */
(function () {
  if (window.__ppV9) return; window.__ppV9 = true;
  var css = ''
  /* C */
  + '.bold_option_swatch .bold_option_value{position:relative}'
  + '.bold_option_swatch .bold_option_value.pp-sel .bold_option_value_swatch{box-shadow:0 0 0 4px #1f3d2b!important;border-color:#1f3d2b!important;border-radius:4px}'
  + '.bold_option_swatch .bold_option_value.pp-sel::after{content:"\\2713";position:absolute;top:-8px;right:-8px;width:26px;height:26px;border-radius:50%;background:#1f3d2b;color:#fff;font:700 16px/26px sans-serif;text-align:center;z-index:2;box-shadow:0 1px 3px rgba(0,0,0,.3);pointer-events:none}'
  + '.pp-added{display:block;margin-top:8px;font-size:13px;font-weight:700;color:#1f3d2b;text-align:center;line-height:1.2}'
  /* A */
  + '.bold_option.pp-missing{background:#fff5f5;outline:3px solid #d60000;outline-offset:4px;border-radius:4px}'
  + '.pp-required-error{color:#d9001b!important;font-size:15px!important;font-weight:700;margin-top:6px}'
  /* E */
  + '#bold-modal__window.bold-modal__window{top:max(5dvh,12px)!important;bottom:auto!important;height:auto!important;max-height:90vh!important;max-height:90dvh!important;display:flex!important;flex-direction:column;overflow:hidden!important;padding-bottom:0!important;box-sizing:border-box}'
  + '#bold-modal__window .bold-modal__window_content{display:flex!important;flex-direction:column;flex:1 1 auto;min-height:0;max-height:inherit;position:relative}'
  + '#bold-modal__window .bold-modal__content{flex:1 1 auto;min-height:0;overflow-y:auto!important;-webkit-overflow-scrolling:touch;overscroll-behavior:contain}'
  + '#bold-modal__window .bold-modal__footer{position:relative!important;inset:auto!important;flex:0 0 auto;display:flex!important;gap:8px;background:#fff;border-top:1px solid #e5e5e5;padding:10px 0 calc(10px + env(safe-area-inset-bottom,0px))!important;margin:0!important;width:auto!important;z-index:5}'
  + '#bold-modal__window .bold-modal__footer .bold-upsell__button{flex:1 1 0;min-height:52px!important;margin:0!important;font-size:16px!important;padding:8px 10px!important;white-space:normal;line-height:1.2}'
  + '#bold-modal__window .bold-modal__footer .bold-upsell__button--secondary{flex:1.4 1 0;background:#1f3d2b!important;color:#fff!important;border-color:#1f3d2b!important;font-weight:700}'
  + '#bold-modal__window .bold-modal__btn-close{width:44px!important;height:44px!important;top:2px!important;right:2px!important;display:flex!important;align-items:center;justify-content:center;z-index:10}'
  + '#bold-modal__window .bold-modal__btn-close svg{width:20px;height:20px}'
  + '@media(max-width:749px){#bold-modal__window.bold-modal__window{left:12px!important;right:12px!important;width:auto!important}}';
  var st = document.createElement('style'); st.id = 'pp-v9-css'; st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function isVisible(el) { return !!(el && (el.offsetParent || el.getClientRects().length)); }
  function title(o) { var t = o.querySelector('.bold_option_title'); return t ? t.textContent.trim() : ''; }
  function isRequired(o) { return /\*\s*$/.test(title(o)); }
  function money(c) { return '$' + (c / 100).toFixed(2) + ' USD'; }
  function parseMoney(t) { var m = (t || '').replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/); return m ? Math.round(parseFloat(m[1]) * 100) : 0; }
  function opts(root) { return [].slice.call((root || document).querySelectorAll('.bold_options_loaded .bold_option')).filter(function (o) { return !o.classList.contains('bold_option_hidden') && isVisible(o); }); }
  function mainForm() {
    var b = document.querySelector('form .bold_clone[name=add]');
    return (b && b.form) || (document.querySelector('.bold_options_loaded') || {closest: function () { return null; }}).closest('form');
  }
  function missing(form) {
    return opts(form).filter(function (o) {
      if (!isRequired(o) || !/bold_option_(swatch|radio|dropdown)\b/.test(o.className)) return false;
      var ok = false;
      o.querySelectorAll('input[type=checkbox],input[type=radio]').forEach(function (i) { if (i.checked) ok = true; });
      o.querySelectorAll('select').forEach(function (s) { if (s.value) ok = true; });
      return !ok;
    });
  }
  function flag(list) {
    list.forEach(function (o) {
      o.classList.add('pp-missing');
      if (!o.querySelector('.pp-required-error')) {
        var m = document.createElement('div'); m.className = 'pp-required-error'; m.setAttribute('role', 'alert');
        m.textContent = 'This option is required.'; o.appendChild(m);
      }
      o.addEventListener('change', function h() { o.classList.remove('pp-missing'); var e = o.querySelector('.pp-required-error'); if (e) e.remove(); o.removeEventListener('change', h); });
    });
    if (list[0]) list[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  window.__ppMissing = function () { var f = mainForm(); return f ? missing(f).map(title) : []; };

  /* A) guard real Add to Cart clicks before the app's own handlers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[name=add],input[name=add],.bold_clone');
    if (!b || !b.form || !b.form.querySelector('.bold_options_loaded')) return;
    var miss = missing(b.form);
    if (!miss.length) return;
    e.preventDefault(); e.stopImmediatePropagation(); flag(miss);
  }, true);
  /* A) sticky bar button: one tap adds (or shows what's missing). Capture phase replaces the old scroll-only handler. */
  document.addEventListener('click', function (e) {
    var sb = e.target.closest && e.target.closest('#wm-sticky-atc button');
    if (!sb) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var f = mainForm(); if (!f) return;
    var miss = missing(f);
    if (miss.length) { flag(miss); return; }
    var add = [].slice.call(f.querySelectorAll('.bold_clone[name=add],button[name=add]')).filter(isVisible)[0];
    if (add) add.click(); else f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  /* B) Classy Gift Wrap -> No */
  var wrapTouched = false;
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('.bold_option');
    if (o && /Classy Gift Wrap/i.test(title(o)) && e.isTrusted && e.target.closest('.bold_option_value')) wrapTouched = true;
  }, true);
  function presetWrap() {
    if (wrapTouched || !/^\/(collections\/[^/]+\/)?products\//.test(location.pathname)) return;
    opts().forEach(function (o) {
      if (!/Classy Gift Wrap/i.test(title(o))) return;
      var no = null, yes = null;
      o.querySelectorAll('input[type=radio]').forEach(function (r) { if (/^\s*No\s*$/i.test(r.value)) no = r; else if (r.checked) yes = r; });
      if (no && !no.checked) {
        var lab = no.closest('label'); if (lab) lab.click();               /* same path as a real tap */
        if (!no.checked) { no.checked = true; }
        no.dispatchEvent(new Event('change', { bubbles: true }));
        no.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  /* C + D */
  var sticky = document.querySelector('#wm-sticky-atc .wm-sticky-atc__price');
  function basePrice() {
    try {
      var f = mainForm(), id = f && f.querySelector('[name=id]') && f.querySelector('[name=id]').value;
      var vs = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants;
      if (vs) for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id)) return vs[i].price;
    } catch (err) {}
    return sticky ? (+sticky.getAttribute('data-pp-base') || 0) : 0;
  }
  if (sticky && !sticky.getAttribute('data-pp-base')) sticky.setAttribute('data-pp-base', parseMoney(sticky.textContent));
  function refresh() {
    var extras = 0;
    document.querySelectorAll('.bold_options_loaded .bold_option_swatch .bold_option_value').forEach(function (v) {
      var i = v.querySelector('input[type=checkbox]'); var on = !!(i && i.checked) && !v.closest('.bold_option_hidden');
      v.classList.toggle('pp-sel', on);
      var lab = v.querySelector('.pp-added'), pr = v.querySelector('.bold_option_value_price');
      if (on) { var t = 'Added' + (pr && parseMoney(pr.textContent) ? ' +' + money(parseMoney(pr.textContent)).replace(' USD', '') : '');
        if (!lab) { lab = document.createElement('span'); lab.className = 'pp-added'; v.appendChild(lab); } if (lab.textContent !== t) lab.textContent = t; }
      else if (lab) lab.remove();
    });
    opts().forEach(function (o) {
      o.querySelectorAll('input:checked').forEach(function (i) {
        var v = i.closest('.bold_option_value'), pr = v && v.querySelector('.bold_option_value_price');
        if (pr) extras += parseMoney(pr.textContent);
      });
      o.querySelectorAll('select').forEach(function (s) { var op = s.options[s.selectedIndex]; if (op && s.value) { var m = op.textContent.match(/\$\s?[\d.,]+/); if (m) extras += parseMoney(m[0]); } });
    });
    var real = document.querySelector('.bold_option_total .money');
    if (real) extras = parseMoney(real.textContent);
    if (sticky) { var t = money(basePrice() + extras); if (sticky.textContent !== t) sticky.textContent = t; }
  }
  var q;
  function schedule() { clearTimeout(q); q = setTimeout(function () { presetWrap(); refresh(); }, 120); }
  document.addEventListener('change', schedule, true);
  document.addEventListener('click', function () { setTimeout(schedule, 50); }, true);
  var n = 0, iv = setInterval(function () { schedule(); if (++n > 60) clearInterval(iv); }, 250);
  /* v10: keep the wrap preset for the whole page view - Zepto loads late on phones and re-renders options
     (e.g. after the gift box answer); Safari can also restore an old form state from bfcache. */
  var mo; new MutationObserver(function () { clearTimeout(mo); mo = setTimeout(schedule, 80); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  window.addEventListener('pageshow', function () { setTimeout(schedule, 50); setTimeout(schedule, 800); });

  /* E) footer label */
  function relabel() {
    document.querySelectorAll('#bold-modal__window .bold-upsell__button--secondary').forEach(function (b) {
      if (!b.classList.contains('pp-busy') && !b.closest('.pp-footer-busy') && b.textContent.trim() !== 'No thanks, continue') { b.textContent = 'No thanks, continue'; b.title = 'No thanks, continue'; }
    });
    var x = document.querySelector('#bold-modal__window .bold-modal__btn-close'); if (x && !x.getAttribute('aria-label')) { x.setAttribute('aria-label', 'Close'); x.setAttribute('role', 'button'); }
  }
  var rq; new MutationObserver(function () { if (rq) return; rq = requestAnimationFrame(function () { rq = 0; if (document.getElementById('bold-modal__window')) relabel(); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();


/* === PP v10 (Oct 18): instant "Adding..." feedback ===
   Main Add to Cart / sticky button and the Bold pop-up footer buttons show "Adding..." + spinner on tap,
   ignore repeat taps (no double adds) and restore when the pop-up opens/closes, the cart updates,
   a required-option error shows, or after a fallback timeout. Never sets the real "disabled" attribute
   during the tap (that would cancel the form submit); state is applied right after the click dispatches.
   Remove this block to roll back. */
(function () {
  if (window.__ppV10) return; window.__ppV10 = true;
  var st = document.createElement('style');
  st.textContent = '.pp-busy{pointer-events:none!important;opacity:.85;cursor:progress!important}'
   + '.pp-spin{display:inline-block;width:1em;height:1em;margin-right:8px;vertical-align:-2px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:ppspin .7s linear infinite}'
   + '@keyframes ppspin{to{transform:rotate(360deg)}}'
   + '.pp-footer-busy .bold-upsell__button{pointer-events:none!important}.pp-footer-busy .bold-upsell__button:not(.pp-busy){opacity:.45}'
   + '.pp-footer-busy{position:relative}.pp-footer-busy::before{content:"";position:absolute;left:0;top:0;height:3px;width:30%;background:#1f3d2b;animation:ppbar 1.1s ease-in-out infinite}'
   + '@keyframes ppbar{0%{left:0;width:10%}50%{left:45%;width:40%}100%{left:100%;width:10%}}';
  document.head.appendChild(st);
  function busy(b) { if (!b || b.classList.contains('pp-busy')) return; b.setAttribute('data-pp-html', b.innerHTML); b.classList.add('pp-busy'); b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); b.innerHTML = '<span class="pp-spin" aria-hidden="true"></span>Adding\u2026'; }
  function unbusy(b) { if (!b || !b.classList.contains('pp-busy')) return; b.innerHTML = b.getAttribute('data-pp-html'); b.classList.remove('pp-busy'); b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
  function popupOpen() { var w = document.getElementById('bold-modal__window'); return !!(w && w.getBoundingClientRect().height); }
  function errShown() { return !!document.querySelector('.pp-missing, .bold_option_error'); }
  var mainBusy = false, mainT0 = 0, popBusy = false, popT0 = 0;
  function mainButtons() { return [].slice.call(document.querySelectorAll('#wm-sticky-atc button, form[action*="/cart/add"] .bold_clone[name=add], form[action*="/cart/add"] button[name=add]')).filter(function (b) { return b.offsetParent || b.getClientRects().length; }); }
  function endMain() { mainBusy = false; mainButtons().forEach(unbusy); }
  function endPop() { popBusy = false; document.querySelectorAll('.bold-modal__footer').forEach(function (f) { f.classList.remove('pp-footer-busy'); f.querySelectorAll('.bold-upsell__button').forEach(unbusy); }); }
  /* block repeat taps while busy (capture, before everyone) */
  document.addEventListener('click', function (e) {
    /* only real repeat taps; apps (Customily/Bold) click hidden submit buttons programmatically to finish the add */
    if (!e.isTrusted) return;
    var t = e.target.closest && e.target.closest('.pp-busy, .pp-footer-busy .bold-upsell__button');
    if (t) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  /* start feedback after the click has dispatched (bubble phase on window = last) */
  window.addEventListener('click', function (e) {
    /* (apps call preventDefault on their own buttons, so don't rely on defaultPrevented) */
    var m = e.target.closest && e.target.closest('#wm-sticky-atc button, form[action*="/cart/add"] .bold_clone[name=add], form[action*="/cart/add"] button[name=add]');
    if (m && !mainBusy) { setTimeout(function () { if (document.querySelector('.pp-missing, .pp-msg-err, #pp-msg-modal')) return; mainBusy = true; mainT0 = Date.now(); mainButtons().forEach(busy); }, 0); return; }
    var pb = e.target.closest && e.target.closest('#bold-modal__window .bold-modal__footer .bold-upsell__button');
    if (pb && !popBusy) { setTimeout(function () { popBusy = true; popT0 = Date.now(); var f = pb.closest('.bold-modal__footer'); if (f) f.classList.add('pp-footer-busy'); busy(pb); }, 0); }
  }, true);  /* window capture: apps stopPropagation on their own buttons */
  var cartChanged = 0;
  if ('PerformanceObserver' in window) { try { new PerformanceObserver(function (l) { l.getEntries().forEach(function (en) { if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(en.name)) cartChanged = Date.now(); }); }).observe({ type: 'resource', buffered: false }); } catch (err) {} }
  setInterval(function () {
    var now = Date.now();
    if (mainBusy) {
      var done = popupOpen() || errShown() || (cartChanged > mainT0 && now - cartChanged > 600) || now - mainT0 > 8000;
      if (done) endMain();
    }
    if (popBusy) {
      if (!popupOpen() || now - popT0 > 10000) endPop();
    }
  }, 150);
})();

/* === PP v10b (Oct 18): required "Add a message to your potato?" Yes/No (theme-only, not a Zepto option) ===
   Inserted above the potato message box on every product that has one. No default.
   Yes -> show the box (Add to Cart with it empty scrolls to it with a prompt). No -> hide + clear the box.
   Unanswered -> Add to Cart scrolls to the choice. The choice inputs have no name, so nothing extra goes
   on the cart line; only the message itself (Zepto's own field). Remove this block to roll back. */
(function () {
  if (window.__ppMsgChoice) return; window.__ppMsgChoice = true;
  var choice = null; /* 'yes' | 'no' | null */
  var css = document.createElement('style');
  css.textContent = '.pp-msgc{margin:0 0 18px;padding:0;scroll-margin-top:90px}.pp-msgc__t{display:block;font-weight:700;text-transform:uppercase;font-size:15px;margin-bottom:8px;letter-spacing:.02em}'
   + '.pp-msgc__row{display:flex;gap:10px}.pp-msgc label{flex:1;display:flex;align-items:center;justify-content:center;gap:8px;min-height:48px;border:2px solid #cfcfcf;border-radius:8px;font-size:16px;font-weight:600;cursor:pointer;background:#fff;color:#111}'
   + '.pp-msgc input{position:absolute;opacity:0;pointer-events:none}.pp-msgc label.pp-on{border-color:#1f3d2b;background:#eef5f0;box-shadow:0 0 0 2px #1f3d2b inset}'
   + '.pp-msgc.pp-bad,.bold_option.pp-msg-bad{outline:3px solid #d60000;outline-offset:4px;border-radius:6px;background:#fff5f5}'
   + '.pp-msg-err{color:#d9001b;font-size:15px;font-weight:700;margin-top:8px}.bold_option.pp-msg-hidden{display:none!important}';
  document.head.appendChild(css);
  function msgOpt() {
    var os = document.querySelectorAll('.bold_options_loaded .bold_option');
    for (var i = 0; i < os.length; i++) { var t = os[i].querySelector('.bold_option_title'); if (t && /potato message/i.test(t.textContent) && os[i].querySelector('textarea,input[type=text]')) return os[i]; }
    return null;
  }
  function box(o) { return o && o.querySelector('textarea,input[type=text]'); }
  function err(el, txt) {
    clear(); el.classList.add(el.classList.contains('pp-msgc') ? 'pp-bad' : 'pp-msg-bad');
    var m = document.createElement('div'); m.className = 'pp-msg-err'; m.setAttribute('role', 'alert'); m.textContent = txt; el.appendChild(m);
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function clear() { document.querySelectorAll('.pp-msg-err').forEach(function (e) { e.remove(); }); document.querySelectorAll('.pp-bad,.pp-msg-bad').forEach(function (e) { e.classList.remove('pp-bad', 'pp-msg-bad'); }); }
  function apply() {
    var o = msgOpt(); if (!o) return;
    var c = o.previousElementSibling && o.previousElementSibling.classList.contains('pp-msgc') ? o.previousElementSibling : null;
    if (!c) {
      c = document.createElement('div'); c.className = 'pp-msgc'; c.setAttribute('role', 'radiogroup'); c.setAttribute('aria-label', 'Add a message to your potato?');
      c.innerHTML = '<span class="pp-msgc__t">Add a message to your potato? *</span><div class="pp-msgc__row">'
        + '<label data-v="yes"><input type="radio" data-pp-msg="yes">Yes</label><label data-v="no"><input type="radio" data-pp-msg="no">No</label></div>';
      o.parentNode.insertBefore(c, o);
      c.addEventListener('click', function (e) {
        var l = e.target.closest('label[data-v]'); if (!l) return; e.preventDefault();
        choice = l.getAttribute('data-v'); clear(); apply();
        if (choice === 'yes') { var b = box(msgOpt()); if (b) setTimeout(function () { try { b.focus({ preventScroll: true }); } catch (x) {} b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60); }
        else { var b2 = box(msgOpt()); if (b2 && b2.value) { b2.value = ''; b2.dispatchEvent(new Event('input', { bubbles: true })); b2.dispatchEvent(new Event('change', { bubbles: true })); } }
      });
    }
    c.querySelectorAll('label[data-v]').forEach(function (l) { var on = l.getAttribute('data-v') === choice; l.classList.toggle('pp-on', on); l.querySelector('input').checked = on; });
    o.classList.toggle('pp-msg-hidden', choice !== 'yes');
  }
  window.__ppMsgChoiceState = function () { return choice; };
  function guard(e) {
    var t = e.target.closest && e.target.closest('#wm-sticky-atc button, form[action*="/cart/add"] .bold_clone[name=add], form[action*="/cart/add"] button[name=add]');
    if (!t) return; var o = msgOpt(); if (!o) return;
    var c = o.previousElementSibling;
    if (!choice) { e.preventDefault(); e.stopImmediatePropagation(); err(c, 'Please choose Yes or No.'); return; }
    if (choice === 'yes' && !box(o).value.trim()) { e.preventDefault(); e.stopImmediatePropagation(); err(o, 'Type your message, or choose No above.'); try { box(o).focus({ preventScroll: true }); } catch (x) {} }
  }
  window.addEventListener('click', guard, true);   /* window capture = runs before every other add handler */
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('.pp-msg-bad')) clear(); }, true);
  var q; new MutationObserver(function () { clearTimeout(q); q = setTimeout(apply, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  apply(); window.addEventListener('pageshow', apply);
})();

/* === PP v11 (Oct 18): add-to-cart integrity guard REMOVED (v11b) — its re-adds fought the app's orphan-add-on cart cleanup on desktop and dropped add-ons. The Halloween fix is the isTrusted check in the double-tap guard above. === */

/* === PP v11 (Oct 18): pillow / Customily — sticky "Personalize & add to cart" bar was covered ===
   After a photo upload Customily's image toolbar (.customily-mobile-controls) lives in an in-page layer
   with z-index:1000 (.cl-canvas-container), above the sticky bar (z 999), so at the top of the page the
   toolbar sat on top of the bar and swallowed taps. The toolbar scrolls with the page (not fixed), so the
   bar just needs to be above it; the toolbar is reachable by scrolling a little. */
(function () {
  var st = document.createElement('style');
  st.textContent = '#wm-sticky-atc.wm-sticky-atc{z-index:1001!important}';
  document.head.appendChild(st);
})();

/* === PP v11c (Oct 18, rev2): protect the main product from the options app's positional cart cleanup ===
   options.shopapps.site/js/options.js removes "orphan" add-on lines with positional
   /cart/update.js {"updates":[0,0]} right after its own /cart/add.js calls. If that lands after the
   main product /cart/add (Shopify inserts new lines first), the positions point at the potato and the
   cart empties. Fix: rewrite positional zero-updates into key-based ones that may only remove hidden
   option add-on lines (product_type OPTIONS_HIDDEN_PRODUCT); a real product is never zeroed this way. */
(function () {
  if (window.__ppV11c) return; window.__ppV11c = true;
  var of = window.fetch, mainBusy = 0, mainDone = 0;
  function isMain(url, b) { return /\/cart\/add(\?|$)/.test(url) || (/\/cart\/add\.js/.test(url) && b instanceof FormData); }
  function track(p) { mainBusy++; var d = function () { mainBusy--; mainDone = Date.now(); }; p.then(d, d); return p; }
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__ppcu = String(u || ''); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (b) { try { if (isMain(this.__ppcu, b)) { mainBusy++; this.addEventListener('loadend', function () { mainBusy--; mainDone = Date.now(); }); } } catch (e) {} return xs.apply(this, arguments); };
  document.addEventListener('submit', function (e) { if (e.target && /\/cart\/add/.test(e.target.action || '')) mainDone = Date.now() + 4000; }, true);
  window.fetch = function (u, o) {
    try {
      var url = String(u && u.url || u || '');
      if (isMain(url, o && o.body)) return track(of.apply(this, arguments));
      if (/\/cart\/update(\.js)?(\?|$)/.test(url) && o && typeof o.body === 'string' && o.body.charAt(0) === '{') {
        var j = JSON.parse(o.body), self = this, args = arguments;
        if (Array.isArray(j.updates) && j.updates.every(function (q) { return Number(q) === 0; })) {
          /* cleanup racing the main add: concurrent cart writes lose one of them (empty cart). The add-ons
             belong to the potato being added, so they are not orphans: skip the cleanup. */
          if (mainBusy > 0 || Date.now() - mainDone < 5000) return of('/cart.js', { credentials: 'same-origin' });
          return of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
            var upd = {}, n = 0;
            j.updates.forEach(function (q, i) { var it = c.items[i]; if (it && it.product_type === 'OPTIONS_HIDDEN_PRODUCT') { upd[it.key] = 0; n++; } });
            if (!n) return of('/cart.js', { credentials: 'same-origin' });
            var o2 = Object.assign({}, o, { body: JSON.stringify(Object.assign({}, j, { updates: upd })) });
            return of.call(self, u, o2);
          }).catch(function () { return of.apply(self, args); });
        }
      }
    } catch (e) {}
    return of.apply(this, arguments);
  };
})();

/* === PP v14 (Oct 21): main-product guard (v14c: pop-up wait capped, late-add dedupe, trace; v14b: in-flight wait, double confirm, post-re-add reconcile) ===
   v11's integrity guard only acts after it has SEEN the main /cart/add. If the options app commits the
   add-ons on tap but the main add never fires / fails / times out (very slow page, app script hang),
   v11 does nothing and the cart holds only add-ons. v14: on each Add-to-Cart click, snapshot the main
   form and record the cart line keys returned by /cart/add(.js) during that click. After the pop-up
   closes and adds settle, verify /cart.js; if the main variant is missing, re-add it from the snapshot;
   if that fails, remove ONLY the lines added by that click (by key) and show an error. Remove to roll back. */
(function () {
  if (window.__ppV14) return; window.__ppV14 = true;
  var click = null, own = false, timer, pending = 0;
  function T(m) { try { var a = JSON.parse(sessionStorage.getItem('pp14log') || '[]'); a.push(new Date().toISOString().slice(11, 19) + ' ' + m); sessionStorage.setItem('pp14log', JSON.stringify(a.slice(-40))); } catch (e) {} }
  function isAdd(u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); }
  function form() { return document.querySelector('form[action*="/cart/add"] [name=id]') && document.querySelector('form[action*="/cart/add"] [name=id]').form; }
  function grab(t) { if (!click) return; try { var j = JSON.parse(t); (j.items || [j]).forEach(function (i) { if (i && i.key) click.keys[i.key] = 1; }); } catch (e) {} }
  function bump() { if (click) { clearTimeout(timer); timer = setTimeout(check, 6000); } }

  function lateDedupe() { var o; try { o = JSON.parse(sessionStorage.getItem('pp14rk') || 'null'); } catch (e) {} if (!o || Date.now() - o.t > 90000) return;
    setTimeout(function () { of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var m = c.items.filter(function (i) { return String(i.variant_id) === o.id; }), q = m.reduce(function (a, i) { return a + i.quantity; }, 0), mine = m.filter(function (i) { return i.key === o.k; })[0];
      if (q > 1 && mine && m.length > 1) { var u = {}; u[o.k] = mine.quantity - 1; sessionStorage.removeItem('pp14rk'); T('late dedupe ' + JSON.stringify(u)); window.__ppReconciled = (window.__ppReconciled || 0) + 1;
        return of('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }).then(function () { document.dispatchEvent(new CustomEvent('pp:cart-repaired')); }); }
    }).catch(function () {}); }, 2500); }
  document.addEventListener('pp:late-add', lateDedupe);
  var of = window.fetch;
  window.fetch = function (u, o) {
    var p = of.apply(this, arguments);
    try { if (!own && isAdd(u && u.url || u)) p.then(function () { document.dispatchEvent(new Event('pp:late-add')); }, function () {}); if (!own && click && isAdd(u && u.url || u)) { click.adds++; pending++; bump(); p.then(function (r) { pending--; r.clone().text().then(grab); bump(); }, function () { pending--; bump(); }); } } catch (e) {}
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__pp14 = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    try { var x = this; if (!own && isAdd(x.__pp14)) x.addEventListener('loadend', function () { document.dispatchEvent(new Event('pp:late-add')); }); if (!own && click && isAdd(x.__pp14)) { click.adds++; pending++; bump(); x.addEventListener('loadend', function () { pending--; try { grab(x.responseText); } catch (e) {} bump(); }); } } catch (e) {}
    return xs.apply(this, arguments);
  };
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('form[action*="/cart/add"] [name=add], form[action*="/cart/add"] .bold_clone, form[action*="/cart/add"] [type=submit], #wm-sticky-atc button')) return;
    var f = form(); if (!f) return;
    document.querySelectorAll('.pp-main-add-err').forEach(function (n) { n.remove(); }); window.__ppMainAddErr = false;
    var ent = []; new FormData(f).forEach(function (v, k) { if (typeof v === 'string' && v !== '') ent.push([k, v]); });
    var id = (ent.find(function (x) { return x[0] === 'id'; }) || [])[1]; if (!id) return;
    if (click && Date.now() - click.t < 3000) return;   /* double tap: same click */
    var bid = (ent.find(function (x) { return /_boldBuilderId/.test(x[0]); }) || [])[1];
    click = { t: Date.now(), id: String(id), entries: ent, keys: {}, adds: 0, tries: 0, ptries: 0, bid: bid, pre: null };
    var me = click; of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { me.pre = {}; c.items.forEach(function (i) { me.pre[i.key] = 1; }); }).catch(function () {});
    T('click id=' + id); clearTimeout(timer); timer = setTimeout(check, 8000);
  }, true);
  function popupOpen() { var m = document.getElementById('bold-modal__window'); return !!(m && m.getBoundingClientRect().height); }
  function check() {
    var c = click; if (!c) return;
    if (pending > 0 && ++c.tries < 40) { timer = setTimeout(check, 1500); return; }
    if (popupOpen() && ++c.ptries < 4) { timer = setTimeout(check, 1500); return; }   /* v14c: don't wait forever on an ignored pop-up */
    if (!c.confirmed) { c.confirmed = true; timer = setTimeout(check, 3000); return; }   /* v14b: confirm twice, 3s apart, before acting */
    
    of('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.items.some(function (i) { return String(i.variant_id) === c.id; })) { T('main present'); click = null; return; }
      T('main missing; lines=' + cart.items.length);
      /* lines added by THIS click: keys seen in add responses, or lines carrying this click's Bold builder id,
         or (when neither is known) Bold add-on lines that were not in the cart just before the click */
      var mine = cart.items.filter(function (i) { var b = (i.properties || {})._boldBuilderId;
        return c.keys[i.key] || (c.bid && b && String(b) === String(c.bid)) || (!c.bid && b && c.pre && !c.pre[i.key]); });
      if (!mine.length && !c.adds) { click = null; return; }   /* the click added nothing (validation blocked it) */
      own = true; window.__ppMainReadds = (window.__ppMainReadds || 0) + 1; T('readd');
      var fd = new FormData(); c.entries.forEach(function (x) { fd.append(x[0], x[1]); }); fd.set('quantity', '1');
      return of('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin' }).then(function (r) {
        if (r.ok) { return r.json().then(function (j) { var rk = j && j.key; var before = {}; cart.items.forEach(function (i) { before[i.key] = 1; });
          /* v14b reconcile: if the app's late main add also landed, drop OUR re-added line; drop any duplicate line produced by the re-add itself */
          return new Promise(function (ok) { setTimeout(ok, 4000); }).then(function () { return of('/cart.js', { credentials: 'same-origin' }); }).then(function (r2) { return r2.json(); }).then(function (c2) {
            var u = {}, mains = c2.items.filter(function (i) { return String(i.variant_id) === c.id; });
            var q = mains.reduce(function (a, i) { return a + i.quantity; }, 0);
            if (q > 1 && rk && mains.some(function (i) { return i.key === rk; })) u[rk] = Math.max(0, (mains.filter(function (i) { return i.key === rk; })[0].quantity) - 1);
            c2.items.forEach(function (i) { if (!before[i.key] && i.key !== rk && !(c.pre && c.pre[i.key]) && String(i.variant_id) !== c.id && c2.items.some(function (o) { return o.key !== i.key && o.variant_id === i.variant_id && !u.hasOwnProperty(o.key); })) u[i.key] = 0; });   /* v14c: only drop a re-add duplicate if another line of that add-on still remains */
            window.__ppReconciled = (window.__ppReconciled || 0) + Object.keys(u).length; T('reconcile ' + JSON.stringify(u)); if (rk) { try { sessionStorage.setItem('pp14rk', JSON.stringify({ k: rk, id: c.id, t: Date.now() })); } catch (e) {} }
            if (Object.keys(u).length) return of('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) });
          }); }).catch(function () {}).then(function () { own = false; click = null; document.dispatchEvent(new CustomEvent('pp:cart-repaired')); }); }
        throw new Error('readd ' + r.status);
      }).catch(function () {
        var u = {}; mine.forEach(function (i) { u[i.key] = 0; });
        window.__ppOrphanCleanups = (window.__ppOrphanCleanups || 0) + Object.keys(u).length; T('cleanup ' + JSON.stringify(u));
        var done = function () { own = false; click = null; document.dispatchEvent(new CustomEvent('pp:cart-repaired'));
          var n = document.createElement('div'); n.className = 'pp-main-add-err'; n.setAttribute('role', 'alert');
          n.textContent = "Sorry, we couldn't add your potato. Please try Add to Cart again.";
          n.style.cssText = 'position:fixed;left:50%;top:20px;transform:translateX(-50%);z-index:100000;background:#b00020;color:#fff;padding:12px 16px;border-radius:6px;font-size:15px';
          window.__ppMainAddErr = true; n.onclick = function () { n.remove(); }; document.body.appendChild(n); };
        if (!Object.keys(u).length) return done();
        return of('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: u }) }).then(done, done);
      });
    }).catch(function () { own = false; });
  }
})();
